import React from "react";
import objectsSchema from "schemas/objectsSchema";
import CustomInput from "components/CustomInput";
import CustomSelect from "components/CustomSelect";

export default function Step6DateIdentificareCetateanStrain({ formikValues, formikErrors, formikTouched, setFieldValue }) {
   return (
      <>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <label htmlFor="nif">NIF</label>
               <CustomInput
                  id={"nif"}
                  name={"nif"}
                  type={"number"}
                  placeholder={"NIF"}
                  value={formikValues.nif}
                  error={formikErrors.nif}
                  touched={formikTouched.nif}
                  allowNumbersAndPlus={true}
                  setFieldValue={setFieldValue}
               />
            </div>
            <div className="col-md-6">
               <label htmlFor="nrPasaport">Număr Pașaport</label>
               <CustomInput
                  id={"nrPasaport"}
                  name={"nrPasaport"}
                  type={"text"}
                  placeholder={"Număr Pașaport"}
                  value={formikValues.nrPasaport}
                  error={formikErrors.nrPasaport}
                  touched={formikTouched.nrPasaport}
                  setFieldValue={setFieldValue}
                  // maxLengthNumber={6}
                  preventLetters={true}
               />
            </div>
         </div>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <label htmlFor="emisLaPasaport">Dată Emitere</label>
               <CustomInput
                  id={"emisLaPasaport"}
                  name={"emisLaPasaport"}
                  type={"text"}
                  placeholder={"dd.mm.yy"}
                  value={formikValues.emisLaPasaport}
                  error={formikErrors.emisLaPasaport}
                  touched={formikTouched.emisLaPasaport}
                  setFieldValue={setFieldValue}
                  maxLengthText={8}
                  preventLetters={true}
               />
            </div>
            <div className="col-md-6">
               <label htmlFor="expiraLaPasaport">Dată Expirare</label>
               <CustomInput
                  id={"expiraLaPasaport"}
                  name={"expiraLaPasaport"}
                  type={"text"}
                  placeholder={"dd.mm.yy"}
                  value={formikValues.expiraLaPasaport}
                  error={formikErrors.expiraLaPasaport}
                  touched={formikTouched.expiraLaPasaport}
                  setFieldValue={setFieldValue}
                  maxLengthText={8}
                  preventLetters={true}
               />
            </div>
         </div>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <CustomSelect
                  options={objectsSchema.countriesOptions}
                  value={formikValues.taraEmitenta}
                  onChange={value => setFieldValue("taraEmitenta", value.value)}
                  placeholder="Alege Țara..."
                  id={"taraEmitenta"}
                  isError={formikErrors.taraEmitenta && formikTouched.taraEmitenta}
                  name={"taraEmitenta"}
                  labelDescription={"Țara"}
                  obligatoriu={true}
               />
               {formikErrors.taraEmitenta && formikTouched.taraEmitenta && <div className="error-msg">{formikErrors.taraEmitenta}</div>}
            </div>
         </div>
      </>
   );
}
